<script lang="ts">
	import LegalDataPage from '$lib/components/Legal/LegalDataPage.svelte';
	import type { PageLoad } from './$types';

	export let data: PageLoad;
	$: LegalPage = data.LegalPage;
</script>

{#if $LegalPage.data?.legalPage}
	<LegalDataPage pageData={$LegalPage.data.legalPage} />
{:else if $LegalPage.errors}
	Error
{:else if $LegalPage.loadPending}
	Loading
{:else}
	Unknown Error
{/if}
